import { mapGetters } from "vuex";
import { DetectMobile } from "./../../../mixins/detectmobile";
import uuid from "uuid/v1";
import { priceTriggerType } from "../../../api/constants/priceTriggerEnums";
import { calculatePerItemDiscount } from "../../../api/helpers/priceTriggerHelpers";

export default {
  filters: {
    cut: function (value) {
      let n = 140;
      if (!value) return "";
      if (value.length <= n) return value;
      return value.substring(0, n) + "...";
    },
    cutgift: function (value) {
      let n = 50;
      if (!value) return "";
      if (value.length <= n) return value;
      return value.substring(0, n) + "...";
    },
    formatStatus(value, vueObj) {
      let that = vueObj;
      if (value && typeof value == "string") value = parseInt(value);
      let pricing;
      switch (value) {
        case 1:
          pricing = that.$t("message.new");
          break;
        case 2:
          pricing = that.$t("message.popular");
          break;
        case 3:
          pricing = that.$t("message.soldOut");
          break;
        default:
          pricing = "";
          break;
      }
      return pricing;
    },
  },
  computed: {
    ...mapGetters([
      "getUsedLifeStyles",
      "currencySign",
      "apllicablePriceTriggers",
    ]),
    imageRatioStyle() {
      var styles = [];
      if (this.height > this.width) {
        styles = [{ "background-repeat": "no-repeat" }];
      }
      if (this.isRolldStore()) {
        if (!this.isMobile()) {
          styles.push({ "margin-top": "10px" });
          styles.push({ height: "190px" });
          styles.push({ "background-position": "0px -85px" });
          styles.push({ "background-size": "215px 300px" });
        } else {
          styles.push({ "background-position": "-15px -57px" });
          styles.push({ "background-size": "200px 200px" });
        }
      } else {
        styles.push({ "background-position": "center" });
        styles.push({ "border-radius": "5px" })
      }
      return styles;
    },
    dialogImageRatioStyle() {
      var styles = [];
      if (this.height * 1.2 > this.width) {
        styles = [
          { "background-size": "contain" },
          { "background-repeat": "no-repeat" },
          { "background-position": "center" },
        ];
      }
      return styles;
    },
    dietaryList() {
      var that = this;
      var items = [];
      if (this.category.ProductAllergy)
        items = this.category.ProductAllergy.map((p) =>
          that.getUsedLifeStyles.allergies.find((s) => s.Id === p)
        ).filter((p) => p);
      if (this.category.ProductIntolerance)
        items = [
          ...items,
          ...this.category.ProductIntolerance.map((p) =>
            that.getUsedLifeStyles.intolerances.find((s) => s.Id === p)
          ).filter((p) => p),
        ];
      if (this.category.ProductPreference)
        items = [
          ...items,
          ...this.category.ProductPreference.map((p) =>
            that.getUsedLifeStyles.preferences.find((s) => s.Id === p)
          ).filter((p) => p),
        ];
      return items;
    },
    priceOverride() {
      var discount = 0;
      let itemUniqueId = uuid();
      let orderItem = {
        id: this.category.ProductID,
        uniqueId: itemUniqueId,
        code: this.product.ProductCode,
        name: this.category.Name,
        price: this.category.Price,
        ProductCategoryIDs: this.product.ProductCategoryIDs,
        ProductTagIDs: this.product.ProductTagIDs,
        quantity: 1,
        modifiers: [],
      };
      this.apllicablePriceTriggers(orderItem)
        .filter(
          (pt) =>
            pt.type == priceTriggerType.perItemDiscountPriceTriggers &&
            pt.order == itemUniqueId
        )
        .forEach((pt) => {
          discount += calculatePerItemDiscount(pt, orderItem);
        });
      if (discount === 0) {
        return null;
      }
      return orderItem.price - discount;
    },
  },
  methods: {
    showModal() {
      if (
        DetectMobile.methods.isMobile(true) &&
        this.$root &&
        this.$root.$refs &&
        this.$root.$refs.Productlist &&
        this.$root.$refs.Productlist.$refs &&
        this.$root.$refs.Productlist.$refs.scrollview
      ) {
        this.$root.$refs.Productlist.$refs.scrollview.style.position = "";
      }
      if (this.status === undefined) {
        this.isModalVisible = this.product.Status != 3;
      } else {
        this.isModalVisible = this.status != 3;
      }
    },
    closeModal() {
      if (
        DetectMobile.methods.isMobile(true) &&
        this.$root &&
        this.$root.$refs &&
        this.$root.$refs.Productlist &&
        this.$root.$refs.Productlist.$refs &&
        this.$root.$refs.Productlist.$refs.scrollview
      ) {
        this.$root.$refs.Productlist.$refs.scrollview.style.position = "fixed";
      }

      this.isModalVisible = false;
    },
    getImageWidthHeight() {
      if (this.product && this.product.PhotoUrl) {
        var image = new Image();
        image.src = this.product.PhotoUrl;
        var that = this;
        image.onload = function () {
          that.width = this.width;
          that.height = this.height;
        };
      }
    },
    getIconStyle(item) {
      if (item && item.Name)
        return [
          {
            "background-image": `url(https://abacus-asset.firebaseapp.com/onlineordering/images/dietary/icon/abacus_dietary_${item.Name.split(
              " "
            ).join("")}.png)`,
          },
        ];
      else return [];
    },
  },
};
